import ReviewIcon from '@mui/icons-material/Comment';
import ReviewList from './ReviewList';
import ReviewCreate from './ReviewCreate';

export default {
    icon: ReviewIcon,
    list: ReviewList,
    create: ReviewCreate,
};
